import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateAnnouncementForm from "../../forms/CreateOrUpdateAnnouncementForm";

interface CreateAnnouncementModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateAnnouncementModal: React.FC<CreateAnnouncementModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Create Announcement"
    width="md"
    loading={loading}
  >
    <CreateOrUpdateAnnouncementForm loading={loading} error={error} />
  </AppModal>
);

export default CreateAnnouncementModal;
